module.exports = __webpack_public_path__ + "img/shopping-cart-grey.5c5b6129.svg";